// app/javascript/controllers/map_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    apiKey: String,
    markers: Array
  }

  connect() {
    if (!window.google || !window.google.maps) {
      if (!window.googleMapsLoading) {
        window.googleMapsLoading = true;
        this.loadGoogleMaps();
      } else {
        const checkLoaded = setInterval(() => {
          if (window.google && window.google.maps) {
            clearInterval(checkLoaded);
            this.initMap();
          }
        }, 50);
      }
    } else {
      this.initMap();
    }
  }

  loadGoogleMaps() {
    if (document.getElementById('google-maps-script')) return;
    const script = document.createElement('script')
    script.id = 'google-maps-script'
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKeyValue}&libraries=marker&callback=initMapCallback`
    script.async = true
    window.initMapCallback = this.initMap.bind(this)
    document.body.appendChild(script)
  }

  initMap() {
    const map = new google.maps.Map(this.element, {
      center: { lat: -27.1, lng: -52.6 }, 
      zoom: 13,
      mapId: "DEMO_MAP_ID",
      disableDefaultUI: true
    })

      this.markersValue.forEach(markerData => {
        const pinContainer = document.createElement("div")
        pinContainer.className = "map-pin-container group cursor-pointer"
        pinContainer.innerHTML = `
          <div class="relative">
            <div class="h-10 w-10 rounded-full border-2 border-white dark:border-slate-800 shadow-lg overflow-hidden bg-white">
              <img src="${markerData.image_url}" class="h-full w-full object-cover">
            </div>
            <div class="absolute -bottom-1 -right-1 bg-indigo-600 rounded-full p-1 border border-white">
              <svg class="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4"/></svg>
            </div>
            <div class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-xs font-bold px-2 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              ${markerData.price}
            </div>
          </div>
        `
        const lat = Number(markerData.lat);
        const lng = Number(markerData.lng);
        if (!isFinite(lat) || !isFinite(lng)) return; // Skip invalid coordinates
        const position = { lat, lng };
        // Create marker only if valid
      const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
          position,
        content: pinContainer,
        title: markerData.title
      })
      marker.addListener("click", () => {
        const infowindow = new google.maps.InfoWindow({
          content: markerData.info_window_html
        })
        infowindow.open({ anchor: marker, map })
      })
    })
  }
}
